import React from 'react';
import { motion } from 'framer-motion';
import { FaMusic, FaTshirt, FaEnvelope, FaGift, FaHeadphones } from 'react-icons/fa';
import GoldenButton from './common/GoldenButton';

const GuestInfo = () => {
  return (
    <section className="min-h-screen py-20 px-4">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.8 }}
        className="max-w-4xl mx-auto"
      >
        <h2 className="text-4xl md:text-5xl font-cursive text-gray-800 mb-16 text-center">
          Para los Invitados
        </h2>

        <div className="grid md:grid-cols-2 gap-8 max-w-4xl mx-auto">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: 0.3 }}
            className="rounded-2xl shadow-xl p-8 flex flex-col items-center text-center"
          >
            <h4 className="text-2xl font-cursive text-[#D4AF37] mb-3">Music List</h4>
            <span className="text-4xl mb-4 text-[#D4AF37]">
              <FaMusic />
            </span>
            <div className="space-y-4">
              <p className="font-serif text-lg">Queremos que seas el DJ de nuestra fiesta</p>
              <p className="font-serif text-lg mb-6">Agrega ese TEMAIQUEN que no puede faltar en la playlist</p>
              <GoldenButton
                onClick={() => window.open('https://open.spotify.com/playlist/2hg66KjRkhEYZbYUd7xO4v?si=RwLukBGjS9Sx0jTyr5QFrQ&pi=n0ZcrtkfTgWjj', '_blank')}
                className="px-6 py-3 flex items-center justify-center gap-2 w-full md:w-auto mx-auto"
              >
                <FaHeadphones className="text-xl" />
                <span>Agregar canciones</span>
              </GoldenButton>
              <p className="font-serif text-sm italic mt-4">
                Agregá tus temas favoritos a la playlist de Spotify
              </p>
              <p className="font-serif text-sm italic mt-4">
                Esta playlist estara disponible 7 dias antes del evento
              </p>
            </div>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: 0.3 }}
            className="rounded-2xl shadow-xl p-8 flex flex-col items-center text-center"
          >
            <h4 className="text-2xl font-cursive text-[#D4AF37] mb-3">Dress Code</h4>
            <span className="text-4xl mb-4 text-[#D4AF37]">
              <FaTshirt />
            </span>
            <div className="space-y-4 mb-12">
              <p className="font-serif text-lg">Primer día: look formal</p>
              <p className="font-serif text-lg italic">¡Pónganse facheros y muy cómodos!</p>
            </div>
            <div className="space-y-4">
              <p className="font-serif text-lg">Segundo dia: look rural</p>
              <p className="font-serif text-lg italic">Modo pile y campo</p>
            </div>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: 0.3 }}
            className="rounded-2xl shadow-xl p-8 flex flex-col items-center text-center"
          >
            <h4 className="text-2xl font-cursive text-[#D4AF37] mb-3">Mensajes en vivo</h4>
            <span className="text-4xl mb-4 text-[#D4AF37]">
              <FaEnvelope />
            </span>
            <div className="space-y-4">
              <p className="font-serif text-lg">¡Enviá tus mensajes para que sean leídos en vivo durante la fiesta! Esta sección estará disponible la noche del 29.</p>
              <p className="font-serif text-lg italic">Los mensaje buena onda seran bienvenidos</p>
              <ul className="font-serif text-sm text-gray-600 space-y-2 mt-2">
                <li>"¡Felicidades chicos! Los quiero mucho ❤️"</li>
                <li>"Que viva el amor! 🎉"</li>
                <li>"Les deseo toda la felicidad del mundo 🥂"</li>
                <li>"La chica de la mesa 14 esta soltera?"</li>
              </ul>
            </div>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: 0.3 }}
            className="rounded-2xl shadow-xl p-8 flex flex-col items-center text-center"
          >
            <h4 className="text-2xl font-cursive text-[#D4AF37] mb-3">Regalos</h4>
            <span className="text-4xl mb-4 text-[#D4AF37]">
              <FaGift />
            </span>
            <div className="space-y-4">
              <p className="font-serif text-lg">Tu presencia es nuestro mejor regalo, pero si querés hacernos un presente, habrá un espacio en la fiesta para que nos dejes alguna sorpresas</p>
            </div>
          </motion.div>
        </div>
      </motion.div>
    </section>
  );
};

export default GuestInfo; 